<script setup>
import { computed, defineEmits, defineProps, ref, watch } from 'vue'
import { t } from '@/i18n'
import { useRouter } from 'vue-router'
import { logoutFunc } from '@/model/user'

const router = useRouter()

const props = defineProps({
    modelValue: Boolean,
})

const emits = defineEmits(['update:modelValue', 'open', 'close'])

let show_a = ref(false)
let show_b = ref(false)

watch(()=> props.modelValue,(_nval) => {
    if(_nval) {
        open()
    }else {
        close()
    }
}, {immediate: true})

function open() {
    show_a.value = true
    setTimeout(() => {
        show_b.value = true
        emits('open')
    }, 100);
}
function close() {
    show_b.value = false
    setTimeout(() => {
        show_a.value = false
        emits('update:modelValue', false)
        emits('close')
    }, 300);
}

const nav_list = computed(()=> {
    return [
        { title: t('开始预订'), path: '/start', icon: require('@/assets/img/nav-start.svg') },
        { title: t('订单历史'), path: '/order', icon: require('@/assets/img/nav-order.svg') },
        { title: t('个人资料'), path: '/mine', icon: require('@/assets/img/nav-profile.svg') },
        { title: t('会员资格'), path: '/vip', icon: require('@/assets/img/nav-vip.svg') },
        { title: t('事件'), path: '/event', icon: require('@/assets/img/nav-event.svg') },
        { title: t('邀请码'), path: '/invite', icon: require('@/assets/img/nav-invite.svg') },
        { title: t('联系我们'), path: '/service', icon: require('@/assets/img/nav-service.svg') },
        { title: t('钱包信息'), path: '/bind', icon: require('@/assets/img/nav-bind.svg') },
        { title: t('提现'), path: '/withdraw', icon: require('@/assets/img/nav-withdraw.svg') },
        { title: t('证书'), path: '/cert', icon: require('@/assets/img/nav-cert.svg') },
    ]
})
function onclickNavItem(item) {
    if(item.path) {
        router.push(item.path)
    }
}
</script>

<template>
    <teleport to='body'>
        <div v-if="show_a" class="w-full h-full fixed left-0 top-0 z-[995]">
            <em @click="close()" class="w-full h-full bg-black/60 block"></em>
            <div :class="show_b ? 'translate-x-0' : 'translate-x-full'"  class="aside_box pt-safe pb-safe">
                <div class="w-full h-full py-5 overflow-y-auto flex flex-col">
                    <div class="w-full p-2.5 mb-5 flex justify-center shrink-0">
                        <img src="@/assets/img/logo.png" class="max-w-full h-7.5 object-contain">
                    </div>
                    <ol class="w-full px-2.5 flex-1">
                        <template v-for="item,index in nav_list" :key="index">
                            <li @click="onclickNavItem(item)" :style="`animation-duration: 0.4s;animation-delay: ${index * 0.1}s;`" class="px-8.5 py-4 cursor-pointer flex items-center animate__animated animate__fadeInRight">
                                <em class="w-6 h-6 mr-4 flex shrink-0">
                                    <img :src="item.icon" class="w-full h-full object-contain">
                                </em>
                                <h5 class="text-base font-medium flex-1 overflow-hidden">
                                    <span>{{ item.title }}</span>
                                </h5>
                            </li>
                        </template>
                    </ol>
                    <a href="javascript:;" @click="logoutFunc()" class="w-full px-11 py-4 mt-5 flex items-center shrink-0">
                        <em class="w-6 h-6 mr-4 flex shrink-0">
                            <img src="@/assets/img/nav-logout.svg" class="w-full h-full object-contain">
                        </em>
                        <h5 class="text-base font-medium flex-1 overflow-hidden">
                            <span>{{ t('退出登录') }}</span>
                        </h5>
                    </a>
                </div>
            </div>
        </div>
    </teleport>
</template>
<style scoped>
.aside_box {
    @apply bg-aside-bg text-aside-text transform right-0 top-0 h-full absolute z-10 duration-300 ease-in-out;
    width: 300px;
    max-width: 95%;
    background-image: url(@/assets/img/bg-2.png);
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
}
</style>